<template>
  <div class="page page-single">
    <HeaderSlide />
    <div class="page-container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
        <el-breadcrumb-item>最新消息</el-breadcrumb-item>
      </el-breadcrumb>
      <article>
        <div class="page-title">
          最新消息 <i class="far fa-newspaper"></i> <a accesskey="C" href="#content" title="content" class="accesskey-content" >:::</a>
        </div>
        <section>
          <el-table 
            :data="news_list" 
            stripe 
            tooltip-effect="dark"
            :default-sort="{prop: 'updateTime', order: 'descending'}"
          >
            <el-table-column prop="id" label="編號" width="60" align="center"></el-table-column>
            <el-table-column prop="news_title" label="標題" min-width="260">
              <template slot-scope="scope">
                <router-link :to="`/news/detail/${scope.row.id}`">{{scope.row.news_title}}</router-link>
              </template>
            </el-table-column>
            <el-table-column prop="online_date" label="更新時間"></el-table-column>
          </el-table>
          <el-pagination 
                class="align-center" 
                @size-change="handle_page_size_change"
                @current-change="handle_current_page_change"
                :current-page="page_num" 
                :page-sizes="[10,20,50]"
                :page-size="page_limit"
                layout="total, prev, pager, next, sizes, jumper " 
                :total="news_total" 
                background
              >
            </el-pagination>
        </section>
      </article>
    </div>
  </div>
</template>

<script>
  import HeaderSlide from '@/components/frontstage/HeaderSlide.vue';
  import api from '@/api/frontstage'

  export default {
    name: 'news',
    components: {
      HeaderSlide,
    },
    async created () {
        this.update_article_list()
    },
    data() {
      return {
        news_list: [],
        page_num: 1,
        page_limit: 10,
        news_total: 0,
      }
    },
    methods: {
        async update_article_list() {
          let params = this.get_serach_params()
          let res = await api.get_latest_news_list(params)
          if (res.success) {
              let self = this
              res['payload']['payload']['search_result'].forEach (function (news) {
                  news['online_date'] = self.getDayFromDateTime(news['online_time'])
              })
              this.news_list = res['payload']['payload']['search_result']
              this.news_total = res['payload']['payload']['search_count']
              console.log('[前臺] news_list: ', this.news_list)
          }
          else {
              this.$set(this, 'news_list', [])
              this.news_total = 0
              this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得列表', res.message)
          }
        },
        getDayFromDateTime(datetime) {
            if (typeof datetime === 'undefined' || typeof datetime['date'] === 'undefined') {
                return ''
            }
            return (datetime['date'].substring(0, datetime['date'].length-7))
        },
        handle_page_size_change (size) {
          this.page_limit = size
          this.page_num = 1
          this.update_article_list()
        },
        handle_current_page_change (page) {
          this.page_num = page
          this.update_article_list()
        },
        get_serach_params () {
          let params = {}

          // pagination
          params['page_num'] = this.page_num
          params['page_limit'] = this.page_limit

          return params
        },
    }
  }
</script>

<style>
  .accesskey-content{
    color: white;
  }
</style>